export const getCornerPostOnPlace = (apiClient) => {
    return {
        calc(lot, postH) {
            return apiClient.request('/3dp/getCornerPostOnPlace', { lot, postH });
        }
    };
};
